import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appResizable]',
  standalone: false
})
export class ResizableDirective {
  private startX: number = 0;
  private startWidth: number = 100;
  private resizing: boolean = false;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent): void {
    this.resizing = true;
    this.startX = event.pageX;
    this.startWidth = this.el.nativeElement.offsetWidth;
    event.preventDefault();
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
    if (this.resizing) {
      let width = this.startWidth + (event.pageX - this.startX);
      width = Math.max(100, Math.min(width, this.startWidth * 1.2));
      this.renderer.setStyle(this.el.nativeElement, 'width', `${width}px`);
    }
  }

  @HostListener('document:mouseup')
  onMouseUp(): void {
    this.resizing = false;
  }
}
